module.exports = __webpack_public_path__ + "assets/img/sta.fc360ec6.png";